import React from 'react';
import { getUserId, getAccessToken } from "../../../utils/user";

/**
 * Whether the current user has credentials.
 * Does not ensure the credentials are valid, only that they exist.
 */
export const hasCredentials = () => getUserId() != null && getAccessToken() != null;
